<app-card [title]="'Physician Information'">
  <form [formGroup]="physicianForm" >
    <div class="profile-container">
      <h2>Physician Details</h2>
      <!-- Row with Physician Name (First and Last) -->
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Physician First Name</mat-label>
          <input matInput type="text" formControlName="physicianFirstName" placeholder="First Name" required>
          <mat-error *ngIf="physicianForm.get('physicianFirstName')?.invalid">First name is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Physician Last Name</mat-label>
          <input matInput type="text" formControlName="physicianLastName" placeholder="Last Name" required>
          <mat-error *ngIf="physicianForm.get('physicianLastName')?.invalid">Last name is required</mat-error>
        </mat-form-field>
      </div>
      <!-- Row with Physician Phone and Email -->
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Physician Phone</mat-label>
          <input matInput type="text" formControlName="physicianPhone" placeholder="Physician Phone" required>
          <mat-error *ngIf="physicianForm.get('physicianPhone')?.invalid">Please enter a valid 10-digit Phone Number.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Physician Email</mat-label>
          <input matInput type="email" formControlName="physicianEmail" placeholder="Physician Email">
          <mat-error *ngIf="physicianForm.get('physicianEmail')?.hasError('email') && physicianForm.get('physicianEmail')?.touched">
            Please enter a valid email address.
          </mat-error>
        </mat-form-field>
        
      </div>

      <!-- Row with Physician Fax -->
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-zipfield">
          <mat-label>Physician Fax</mat-label>
          <input matInput type="text" formControlName="physicianFax" placeholder="Physician Fax">
          <mat-error *ngIf="physicianForm.get('physicianFax')?.invalid">Enter Valid Physician Fax</mat-error>
        </mat-form-field>
      </div>
      <div class="form-row">
        <h2>Physician Address</h2>
      </div>
      <!-- Row with Address Line 1 and Address Line 2 -->
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Address Line 1</mat-label>
          <input matInput type="text" formControlName="physicianAddress1" placeholder="Address Line 1" required>
          <mat-error *ngIf="physicianForm.get('physicianAddress1')?.invalid">Address line 1 is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Address Line 2</mat-label>
          <input matInput type="text" formControlName="physicianAddress2" placeholder="Address Line 2">
        </mat-form-field>
      </div>

      <!-- Row with City and State -->
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>City</mat-label>
          <input matInput type="text" formControlName="physicianCity" placeholder="City" required>
          <mat-error *ngIf="physicianForm.get('physicianCity')?.invalid">City is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>State</mat-label>
          <mat-select formControlName="physicianState" required>
            <mat-option *ngFor="let state of states" [value]="state.stateProvCode">
              {{ state.stateProvName }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="physicianForm.get('physicianState')?.invalid">State is required</mat-error>
        </mat-form-field>
      </div>

      <!-- Row with Zip Code -->
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-zipfield">
          <mat-label>Zip Code</mat-label>
          <input matInput type="text" formControlName="physicianZip" placeholder="Zip Code" required>
          <mat-error *ngIf="physicianForm.get('physicianZip')?.invalid">Please enter a valid ZIP Code.</mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <hr>
      </div>

      <!-- Form Actions (Buttons) -->
      <div class="button-container">
        <button  class="button-Secondary" (click)="onSave(true)" [disabled]="!physicianSubgroup.valid">Save And Exit</button>
        <button  class="button-Primary" (click)="onSave()" [disabled]="!physicianSubgroup.valid">Next : {{nextStep?.enrollmentStepName}}</button>
      </div>
    </div>
  </form>
</app-card>

<loading-spinner *ngIf="isLoading"></loading-spinner>